import React from "react";
import { SliderWithInput } from "@mm/ui";
import { CheckboxList } from "components/molecules";
import "./style.scss";

import dataLayer, {
  reduceCheckboxValues,
  getSliderTouchPoints,
} from "helper/dataLayer";

import { ACTIONS, useFilterProvider } from "../FilterProvider";

import {
  CARRIERS,
  PRICE_RANGE,
  ONE_TIME_PRICE_FROM_RANGE,
  VOLUME_RANGE,
  SPEED_RANGE,
  ADDITIONAL_OPTIONS,
  CONTRACT_TERMS,
} from "../FilterProvider/tariff";

const TariffFilter = () => {
  const {
    state: {
      facets: {
        carriers,
        priceRange,
        oneTimePriceFromRange,
        volumeRange,
        speedRange,
        additionalOptions,
        contractTerms,
      },
      isProductDetailInterface,
      shownFacets,
    },
    dispatch,
  } = useFilterProvider();

  // one time price filter only be shown on PDP Filter
  const showOneTimePriceFromFilter = isProductDetailInterface;

  const entries = [
    {
      key: "filterCarrier",
      header: "Netz / Anbieter",
      facet: "carriers",
      open: true,
      content: (
        <CheckboxList
          list={carriers}
          onChange={(filterGroup) => {
            dispatch({
              type: ACTIONS.UPDATE_FILTER_GROUP,
              payload: {
                filterGroup,
                name: CARRIERS,
              },
            });
            dataLayer({
              eventAction: "click",
              eventCategory: "Filter",
              eventLabel: `Anbieter:${reduceCheckboxValues(filterGroup)}`,
            });
          }}
        />
      ),
    },
    {
      key: "filterContractTerms",
      header: "Laufzeit",
      facet: "contractTerms",
      open: false,
      content: (
        <CheckboxList
          list={contractTerms}
          suffix="Monate"
          onChange={(filterGroup) => {
            dispatch({
              type: ACTIONS.UPDATE_FILTER_GROUP,
              payload: {
                filterGroup,
                name: CONTRACT_TERMS,
              },
            });
            dataLayer({
              eventAction: "click",
              eventCategory: "Filter",
              eventLabel: `Laufzeit:${reduceCheckboxValues(filterGroup)}`,
            });
          }}
        />
      ),
    },
    {
      key: "filterPrice",
      header: "Grundgebühr",
      facet: "priceRange",
      open: false,
      content: (
        <SliderWithInput
          value={priceRange}
          suffix="€"
          onChange={(filterGroup) => {
            if (
              priceRange.min === filterGroup.minVal &&
              priceRange.max === filterGroup.maxVal
            ) {
              dispatch({
                type: ACTIONS.REMOVE_FILTER,
                payload: {
                  filterGroup,
                  group: PRICE_RANGE,
                },
              });
            } else {
              dispatch({
                type: ACTIONS.UPDATE_FILTER_GROUP,
                payload: {
                  filterGroup,
                  name: PRICE_RANGE,
                },
              });
            }
            dataLayer({
              eventAction: "grab",
              eventCategory: "Filter",
              eventLabel: `Preis pro Monat:${getSliderTouchPoints(
                filterGroup
              )}`,
            });
          }}
        />
      ),
    },
    showOneTimePriceFromFilter && {
      key: "filterOneTimePriceFrom",
      header: "Gerätepreis",
      facet: "oneTimePriceFromRange",
      open: false,
      content: (
        <SliderWithInput
          value={oneTimePriceFromRange}
          suffix="€"
          onChange={(filterGroup) => {
            if (
              oneTimePriceFromRange.min === filterGroup.minVal &&
              oneTimePriceFromRange.max === filterGroup.maxVal
            ) {
              dispatch({
                type: ACTIONS.REMOVE_FILTER,
                payload: {
                  filterGroup,
                  group: ONE_TIME_PRICE_FROM_RANGE,
                },
              });
            } else {
              dispatch({
                type: ACTIONS.UPDATE_FILTER_GROUP,
                payload: {
                  filterGroup,
                  name: ONE_TIME_PRICE_FROM_RANGE,
                },
              });
            }
            dataLayer({
              eventAction: "grab",
              eventCategory: "Filter",
              eventLabel: `Einmaliger Gerätepreis:${getSliderTouchPoints(
                filterGroup
              )}`,
            });
          }}
        />
      ),
    },
    {
      key: "filterVolume",
      header: "Datenvolumen",
      facet: "volumeRange",
      open: false,
      content: (
        <SliderWithInput
          value={volumeRange}
          suffix="GB"
          onChange={(filterGroup) => {
            if (
              volumeRange.min === filterGroup.minVal &&
              volumeRange.max === filterGroup.maxVal
            ) {
              dispatch({
                type: ACTIONS.REMOVE_FILTER,
                payload: {
                  filterGroup,
                  group: VOLUME_RANGE,
                },
              });
            } else {
              dispatch({
                type: ACTIONS.UPDATE_FILTER_GROUP,
                payload: {
                  filterGroup,
                  name: VOLUME_RANGE,
                },
              });
            }
            dataLayer({
              eventAction: "click",
              eventCategory: "Filter",
              eventLabel: `Datenvolumen:${getSliderTouchPoints(filterGroup)}`,
            });
          }}
        />
      ),
    },
    {
      key: "filterSpeed",
      header: "Datengeschwindigkeit",
      facet: "speedRange",
      open: false,
      content: (
        <SliderWithInput
          value={speedRange}
          suffix="Mbit/s"
          onChange={(filterGroup) => {
            if (
              speedRange.min === filterGroup.minVal &&
              speedRange.max === filterGroup.maxVal
            ) {
              dispatch({
                type: ACTIONS.REMOVE_FILTER,
                payload: {
                  filterGroup,
                  group: SPEED_RANGE,
                },
              });
            } else {
              dispatch({
                type: ACTIONS.UPDATE_FILTER_GROUP,
                payload: {
                  filterGroup,
                  name: SPEED_RANGE,
                },
              });
            }
            dataLayer({
              eventAction: "click",
              eventCategory: "Filter",
              eventLabel: `Datengeschwindigkeit:${getSliderTouchPoints(
                filterGroup
              )}`,
            });
          }}
        />
      ),
    },
    {
      key: "filterAdditionalOptions",
      header: "Wunschoptionen",
      facet: "additionalOptions",
      open: false,
      content: (
        <CheckboxList
          list={additionalOptions}
          onChange={(filterGroup) => {
            dispatch({
              type: ACTIONS.UPDATE_FILTER_GROUP,
              payload: {
                filterGroup,
                name: ADDITIONAL_OPTIONS,
              },
            });
            dataLayer({
              eventAction: "click",
              eventCategory: "Filter",
              eventLabel: `Wunschoptionen:${reduceCheckboxValues(filterGroup)}`,
            });
          }}
        />
      ),
    },
  ].filter((entry) => shownFacets[entry.facet]);

  return (
    <div className="msd-filter-details__wrapper">
      {entries.map((entry) => (
        <details
          className="msd-filter-details"
          key={entry.key}
          open={entry.open}
        >
          <summary className="msd-filter-details__head">
            <span className="title">{entry.header}</span>
            <span className="arrow"></span>
          </summary>
          {entry.content}
        </details>
      ))}
    </div>
  );
};

export default TariffFilter;
